module.exports = __webpack_public_path__ + "img/03_vedio2.713ebf8c.png";